import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import style from "./header.module.css";
import logo from "../../../assets/nu.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeLink, setActiveLink] = useState(``); // State to track active link

  const menuOpener = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeHandler = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  // const handleLinkClick = (link) => {
  //   setActiveLink(link);
  //   closeHandler();
  // };
  const handleLinkClick = (link) => {
    setActiveLink(link);
    const element = document.getElementById(link);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    closeHandler();
  };

  return (
    <>
      <div className={style.header}>
        <div
          className={style.logoC}
          onClick={() => (window.location.href = "https://nublock.xyz/")}
        >
          <img src={logo} alt="logo" className={style.logo} />

          <span className={style.title}>nuBlock</span>
        </div>
        {!isOpen && <FiMenu onClick={menuOpener} className={style.menuIcon} />}
        {isOpen && (
          <IoClose onClick={closeHandler} className={style.menuIcon} />
        )}
        <div className={style.items}>
          <Link
            to="https://nublock.xyz/"
            className={activeLink === "contact" ? style.active : ""}
          >
            Home
          </Link>
          <Link
            to="https://nublock.xyz/dex"
            className={activeLink === "dex" ? style.active : ""}
          >
            DEX
          </Link>
          {/* <Link
            to="/"
            className={activeLink === "individual" ? style.active : ""}
            onClick={() => handleLinkClick("individual")}

          >
            Individual
          </Link> */}
          {/* <Link
            className={activeLink === "business" ? style.active : ""}
            onClick={() => handleLinkClick("business")}

          >
            Business
          </Link> */}
          {/* <Link
            className={activeLink === "plugins" ? style.active : ""}
            onClick={() => handleLinkClick("plugins")}
          >
            Plugins
          </Link> */}
          <Link to="http://business-portal.nublock.xyz">Portal</Link>
          <Link
            to="https://nublock.xyz/nu"
            className={activeLink === "contact" ? style.active : ""}
            // onClick={() => handleLinkClick("contact")}
          >
            NU
          </Link>
          <Link to="https://nu0-1.gitbook.io/nu-whitepaper">Whitepaper</Link>
          {/* <Link
            to="https://nublock.xyz/prvtapp"
            className={activeLink === "prvtapp" ? style.active : ""}
          >
            PRVT
          </Link> */}
          <Link
            to="https://t.me/Contact_nublock"
            className={activeLink === "contact" ? style.active : ""}
            // onClick={() => handleLinkClick("contact")}
          >
            Contact Us
          </Link>
        </div>
      </div>
      <div className={isOpen ? style.open : style.mobileM}>
        <div className={style.links}>
          <Link
            to="https://nublock.xyz/"
            className={activeLink === "nu" ? style.active : ""}
            onClick={() => handleLinkClick("nu")}
          >
            Home
          </Link>
          <Link
            to="https://nublock.xyz/dex"
            className={activeLink === "dex" ? style.active : ""}
            onClick={() => handleLinkClick("dex")}
          >
            DEX
          </Link>
          {/* <Link
            className={activeLink === "individual" ? style.active : ""}
            onClick={() => handleLinkClick("individual")}
          >
            Individual
          </Link> */}
          {/* <Link
            to="https://nuconsortium.xyz/"
            className={activeLink === "business" ? style.active : ""}
            onClick={() => handleLinkClick("business")}
          >
            Business
          </Link>
          <Link
            // to="/dxs"
            className={activeLink === "plugins" ? style.active : ""}
            onClick={() => handleLinkClick("plugins")}
          >
            Plugins
          </Link> */}
          <Link to="http://business-portal.nublock.xyz">Portal</Link>
          <Link
            to="https://nublock.xyz/nu"
            className={activeLink === "documents" ? style.active : ""}
            onClick={() => handleLinkClick("contact")}
          >
            NU
          </Link>
          <Link to="https://nu0-1.gitbook.io/nu-whitepaper">Whitepaper</Link>
          <Link
            to="https://nublock.xyz/prvtapp"
            className={activeLink === "prvtapp" ? style.active : ""}
            onClick={() => handleLinkClick("prvtapp")}
          >
            PRVT
          </Link>
          <Link
            to="https://t.me/Contact_nublock"
            className={activeLink === "contact" ? style.active : ""}
            onClick={() => handleLinkClick("contact")}
          >
            Contact Us
          </Link>
        </div>
      </div>
    </>
  );
};

export default Header;
